/* tslint:disable */
/* eslint-disable */
export enum Frequency {
  Monthly = 'monthly',
  Bimonthly = 'bimonthly'
}
